import React from 'react';
import styled from 'styled-components';
import {
  BaseBox,
  Heading4,
} from '@docon/docon-ui-library';
import { VideoChat } from 'shared/icons';
import { borderColor, colors } from 'utilities/colorConfig';
import { getAddressString, getTimeFromMinutes } from 'utils';
import { GetDirection } from 'shared';

interface IProps {
  showMoreSlotCard?: boolean,
  rankInitialCount?: number
  slots: any
  clinic?: any
  onClick: (x: any) => void;
}

const Root = styled(BaseBox)`
  display: grid;
  width: 100%;
  margin-bottom: 8px;
  gap: 10px 12px;
  grid-auto-flow: dense;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
`;

const WalkInSlot = styled(BaseBox)`
  padding: 12px 0;
  grid-column: 1/-1;
  text-align: center;
`;

const Slot = styled(Heading4).attrs(() => ({ tagAs: 'div' }))`
  gap: 0 6px;
  padding: 7px 8px;
  display: flex;
  font-weight: 500;
  flex: 0 0 100px;
  flex-wrap: nowrap;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid ${borderColor};
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
  cursor: pointer;

  ${VideoChat} {
    overflow: inherit;
  }
`;

function SlotsContainer({
  showMoreSlotCard,
  rankInitialCount = 0,
  slots = [],
  clinic = {},
  onClick,
  ...props
}: IProps) {

  const handleSlotClick = (slot: any, rank: any = 0) => () => {
    onClick && onClick({ slot: slot ? { ...slot, rank } : slot });
  };

  return (
    <Root {...props}>
      {
        slots.map((slot: any, index: number) =>
          slot.type == 'walkin' ? (
            <WalkInSlot key={slot.startTime}>
              <Heading4
                fontWeight={600}
                title={`Only walk-in from ${getTimeFromMinutes(slot.startTime)} - ${getTimeFromMinutes(slot.endTime)}`}
              />

              <GetDirection address={getAddressString(clinic.address)} />
            </WalkInSlot>
          ) : (
            <Slot key={slot.startTime} onClick={handleSlotClick(slot, rankInitialCount + index + 1)}>
              {slot.parsedStartTime}
              {
                slot.teleConsult ? <VideoChat color={colors.primaryBlue} /> : null
              }
            </Slot>
          ))
      }

      <Slot title={showMoreSlotCard ? 'More' : ''} onClick={handleSlotClick('')} />
    </Root>
  );
}

export default styled(SlotsContainer)``;

